<template>
    <div>
        <textarea
            v-model="valueInner"
            @focusout="focusout"
            @keydown.tab="tab($event)"
            @keyup="saveMousePosition"
            @focusin="saveMousePosition"
            @click="saveMousePosition"
            ref="input"
            :disabled="!isEditable"
        ></textarea>
        <div v-if="errorMessage" class="error-message">{{errorMessage}}</div>
        <v-layout v-else style="height: 20px">
            <div v-for="(variable, i) in filterVariableList" :key="i" class="variable"
                @click="selectVariable(variable)">
                {{variable.name}}
            </div>
        </v-layout>
    </div>
</template>

<script>
import lodash from 'lodash'
import { mapState } from "vuex";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "PromptEditor",
    props: {
        value: String
    },
    data () {
        return {
            valueInner: lodash.unescape(this.value),
            mouseStart: 0,
            searchKey: '',
            errorMessage: ''
        }
    },
    computed: {
        ...mapState({
            variableList: state => state.scenario.variableList,
            isEditable: () => ScenarioService.isEditable()
        }),
        filterVariableList () {
            let list = []
            if (this.searchKey) {
                list = this.variableList.filter(item => item.name.startsWith(this.searchKey))
            } else {
                let mouseStart = this.mouseStart
                let value = this.valueInner
                if (
                    mouseStart > 1 &&
                    value[mouseStart - 1] === '{' &&
                    value[mouseStart - 2] === '{'
                ) {
                    list = this.variableList
                }
            }
            return list.filter((item, i) => i < 5)
        }
    },
    mounted () {
        this.inspectVariable()
    },
    methods: {
        focusout () {
            this.$emit('input', this.valueInner)
            if (this.value !== this.valueInner) {
                this.$emit('input', this.valueInner)
                this.$emit('save')
            }
        },
        tab (e) {
            if (this.filterVariableList.length > 0) {
                e.preventDefault()
                this.selectVariable(this.filterVariableList[0])
            }
        },
        selectVariable (variable) {
            let mouseStart = this.mouseStart
            let value = this.valueInner
            for (let i = mouseStart; i >= 0; i--) {
                if (value[i] === '}') {
                    break
                }
                if (value[i] === '{') {
                    this.searchKey = value.substring(i + 1, mouseStart)
                    let j = -1
                    for (j = mouseStart; j < value.length - 1; j++) {
                        if (value[j] === '}' && value[j+1] === '}') {
                            break
                        }
                    }
                    let append
                    if (j < value.length - 1) {
                        append = value.substring(j)
                    } else {
                        let nextSpaceIndex = value.indexOf(' ', mouseStart)
                        if (nextSpaceIndex > -1){
                            append = '}}' + value.substring(nextSpaceIndex)
                        }else {
                            append = '}}'
                        }
                    }

                    value = value.substring(0, i + 1) + variable.name + append
                    this.valueInner = value
                    let el = this.$refs.input
                    el.focus();
                    if (append !== '}}') {
                        setTimeout(() => {
                            el.setSelectionRange(mouseStart, mouseStart)
                        }, 0)
                    }
                    break
                }
            }
        },
        saveMousePosition () {
            let mouseStart = this.$refs.input.selectionStart
            let value = this.valueInner
            let searchKey = ''
            for (let i = mouseStart - 1; i >= 0; i--) {
                if (value[i] === '}') {
                    break
                }
                if (value[i] === '{') {
                    if (i > 0 && value[i - 1] === '{') {
                        searchKey = value.substring(i + 1, mouseStart)
                    }
                    break
                }
            }
            this.mouseStart = mouseStart
            this.searchKey = searchKey
            this.inspectVariable()
        },
        inspectVariable () {
            let valueInner = this.valueInner
            let i = 0, j = 0
            while (i < valueInner.length) {
                i = valueInner.indexOf('{{', i)
                if (i > -1) {
                    j = valueInner.indexOf('}}', i)
                    if (j > -1) {
                        let name = valueInner.substring(i + 2, j)
                        if (!this.variableList.find(variable => variable.name === name)) {
                            this.errorMessage = name + ' does not exist'
                            return
                        }
                        i = j + 2
                    } else {
                        i = valueInner.length
                    }
                } else {
                    i = valueInner.length
                }
            }
            this.errorMessage = ''
        }
    },
    watch: {
        value () {
            this.valueInner = lodash.unescape(this.value)
        },
        valueInner: 'inspectVariable',
        variableList: 'inspectVariable'
    }
}
</script>

<style scoped>
    .variable {
        height: 20px;
        padding: 0 5px;
        display: flex;
        align-items: center;
        border-radius: 5px;
        border: 1px solid #B2B4C6;
        color: #B2B4C6;
        margin-right: 5px;
        cursor: pointer;
    }

    .error-message {
        color: red;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 13px;
        font-family: "open sans";
    }
</style>
